import {Conversation} from '@stripe-internal/conversations-client';
import {EmailForm} from '../../components/Forms/Email';

type Props = {
  conversation: Conversation;
  attachmentsEnabled?: boolean;
  onCancel: () => void;
};

export const EmailModal = ({
  conversation,
  attachmentsEnabled,
  onCancel,
}: Props) => {
  return (
    <EmailForm
      conversation={conversation}
      onCancel={onCancel}
      attachmentsEnabled={attachmentsEnabled}
    />
  );
};
